// Header.js
import React from 'react';
import { Link } from "react-router-dom";
// import { Tooltip } from 'antd';
// import Title from './Title';
// import HeaderMenu from './HeaderMenu';
// import HeaderArea from './HeaderArea';
// import FrameBreadcrumb from './FrameBreadcrumb';
// import {CaretDownOutlined} from '@ant-design/icons';

import Config from '../config/Config';
import WidgetAjax from './../widget/WidgetAjax';

import 'antd/dist/antd.css';
let systemType=Config.getSystemType();
class Header extends React.Component {
	constructor(props) {
		super(props);

			this.state = {
				realname: undefined,
				location: undefined
			}
		this.freshPage = this.freshPage.bind(this);

		this.headerMenuOnSelect = this.headerMenuOnSelect.bind(this);

		this.logout = this.logout.bind(this);
		this.onLogout = this.onLogout.bind(this);
		this.userInfo = this.userInfo.bind(this);
		this.exitPage = this.exitPage.bind(this);
		this.goGuide = this.goGuide.bind(this);
	}

	componentDidMount() {
		this.userInfo();
	}

	userInfo() {

		let location, realname;
		let data = window.sessionStorage.getItem("_user_info_");

		if (data && data != "undefined") {
			let res = JSON.parse(data);

			if (res !== null && res !== undefined) {
				realname = res.realname;
			}

			let userLoginInfo = window.sessionStorage.getItem("_user_info_");

			userLoginInfo = JSON.parse(userLoginInfo);

			if (userLoginInfo !== null && userLoginInfo.entname !== undefined) {
				location = userLoginInfo.entname;
			}
		}

		this.setState({ realname: realname, location: location })
	}

	headerMenuOnSelect(key) {
		if (this.props.headerOnSelect !== undefined) {
			this.props.headerOnSelect(key);
		}
	}

	freshPage() {
		if (this.props.freshPage !== undefined) {
			this.props.freshPage();
		}
	}

	logout() {
		WidgetAjax.ajax({ url: Config.getBasePath() + '/logout', params: undefined, callback: this.onLogout });
	}
	exitPage() {


		sessionStorage.setItem("_user_access_", '')
		sessionStorage.setItem("_user_info_", '')
		localStorage.setItem("ENTTYPE", '')
		window.location.reload()
	}
	onLogout(result, params) {
		if (result.status === 0) {
			sessionStorage.removeItem("_user_access_");
			sessionStorage.removeItem("_user_info_");
			sessionStorage.removeItem("_user_login_info_");

			if (this.props.redrict !== undefined) {
				this.props.redrict("/login", undefined, true);
			}
		}
	}

	goIndex() {
		
		this.props.redrict("/home/index", undefined, true);
	}
	goGuide() {
		this.props.redrict("/home/guide", undefined, true);
	}
	goPDF() {
		let str = require('../img/business/全国“名特优新”个体工商户培育平台_个体工商户申报手册.pdf')
		window.open(str)
	}
	render() {

		const { location } = this.state;
		return (
			<div className='sg-business-title sd-middle'>
				<div className='sg-title-center sd-spaceBetween' style={{ height: this.props.location.pathname !== '/home/index' ? 'auto' : '128px' }}>
					<div className='sg-center-left sd-start' style={{ display: "flex" }} onClick={() => { this.goIndex() }}>
						<img className='sg-left-img' alt='#' src={require('../img/index/logo.png')} />
						{
							systemType === 'local' ?
								<div style={{ webkitTextFillColor: '#ed6a3b', fontSize: '34px', position: 'relative', bottom: '3px', fontWeight: 'bold' }}>(模拟环境)</div>
								:
								<></>
						}

					</div>

					<div className='sg-center-right sd-end sg-downlod'>
						<div className='sg-right-li sd-start' style={{ cursor: 'pointer' }} onClick={() => { this.goPDF() }}>
							<img className='sg-right-img' alt='#' src={require('../img/index/download.png')} />
							<span className='sg-right-font' style={{ textDecoration: 'underline' }}>用户手册下载</span>
						</div>
						<div className='sg-right-li sd-start' style={{ cursor: 'pointer' }}>
							<img className='sg-right-img' alt='#' src={require('../img/index/user.png')} />
							<Location location={location} exitPage={this.exitPage} goGuide={this.goGuide} />
						</div>
					</div>

				</div>
				<img className='sg-title-img' alt='#' style={{ display: this.props.location.pathname !== '/home/index' ? 'block' : 'none' }} src={require('../img/index/background.png')} />
			</div>
		);

		// let showHeaderArea = Config.isShowHeaderArea();

		// if( this.props.titleNode!==undefined && this.props.titleNode.length!==0 )
		// {
		// 	return (
		// 		<div className='sf-top sd-top sg-top'>
		// 			{/* <FrameBreadcrumb titleNodes={titleNode} leftNodes={leftNode} menuPaths={menuPaths} frameLocation={frameLocation}></FrameBreadcrumb> */}
		// 			{/* <Title title={this.props.systemTitle} /> */}
		// 			<div className='sf-logo sd-logo'>
		// 				<img alt='#' src={require('../img/logo.svg')} />
		// 				<span>{this.props.systemTitle}</span>
		// 			</div>
		// 			<HeaderMenu onSelect={this.headerMenuOnSelect} titleNode={this.props.titleNode} activeKey={activeKey}/>
		// 			<div className="sf-title-right sd-title-right sg-title-right">
		// 				<div className="logout">
		// 					<Location location={location}/>

		// 					<img className="headimg" src={require('../img/frame/user.svg')} alt="es-lint want to get"></img>
		// 					<span style={{padding:'10px',fontSize:'14px'}}>{ realname }</span>
		// 					<span style={{paddingRight:'10px',color:'#999',fontWeight:'bold'}}>｜</span>

		// 					<div className="logout" style={ {paddingRight: '0px'}} onClick={this.logout}>
		// 						<img className="headimg" src={require("../img/frame/logout.svg")} alt="es-lint want to get" />
		// 					</div>
		// 				</div>
		// 			</div>
		// 		</div>
		// 	);
		// }
		// else
		// {
		// 	return(
		// 		<div className='sf-top'>
		// 			{/* <Title title={this.props.systemTitle} /> */}

		// 			{/* <FrameBreadcrumb titleNodes={titleNode} leftNodes={leftNode} menuPaths={menuPaths}></FrameBreadcrumb> */}

		// 			<div className="sf-title-right sd-title-right sg-title-right">
		// 				<div className="logout"> 

		// 					<Location location={location}/>

		// 					<img className="headimg" src={require('../img/frame/user.svg')} alt="es-lint want to get"></img>
		// 					<span style={{padding:'10px',fontSize:'14px'}}>{ realname }</span>
		// 					<span style={{paddingRight:'10px',fontWeight:'bold'}}>|</span>

		// 					<div className="logout" style={ {paddingRight: '0px'}} onClick={this.logout}>
		// 						<img className="headimg" src={require("../img/frame/logout.svg")} alt="es-lint want to get" />
		// 						{/* <span className="out" style={{padding: '10px',fontSize:'14px',color: 'rgb(255, 255, 255)'}}>退出</span> */}
		// 					</div>
		// 				</div>
		// 			</div>
		// 		</div>
		// 	)
		// }

	}
}

export default Header

export const Location = ({ location, exitPage, goGuide }) => {
	// let color = '#ffffff'
	if (location !== undefined) {
		return (
			<div className='sd-middle'>
				<span style={{ padding: '0 4px 0 0', fontSize: '14px' }} onClick={goGuide}>你好！{location}</span>
				<span style={{ fontSize: '14px' }} onClick={exitPage}>退出</span>
				{/* <CaretDownOutlined style={{fontSize:'10px'}}/> */}
				{/* <Tooltip placement="topRight" className='sd-middle' color={color} key='#ffffff' title={<div style={{cursor: 'pointer',color:'#fff'}} onClick={exitPage}>退出登录</div>} >
					
				</Tooltip> */}

				{/* <span style={{paddingRight:'10px',color:'#999',fontWeight:'bold'}}>|</span> */}
			</div>
		)
	}
	else {
		return (<Link className='sg-right-font' to="/home/login">登录</Link>);
	}
}